import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';
import Card from '../components/Ui/Card.jsx';
import { SelectColumnFilter, ServerSidePagingTable } from "../components/Ui/Table.jsx";
import Modal from "../components/Ui/Modal.jsx";
import EyeTicket from "../components/Ui/EyeTicket/EyeTicket.jsx";
import Tracking from "../components/Ui/EyeTicket/Tracking.jsx";
import { fetchOpticiansEyeTickets } from "../http/eyeticket.js";
import { Alert } from "../components/Ui/Alert.jsx";
import { useSearchParams } from 'react-router-dom';
import ProcessEyeTicket from "../components/Ui/EyeTicket/Process.jsx";
import { fetchUsersEyeTickets, updateEyeTicket, fetchTicketStatuses, updateEyeTicketStatus, setEyeTicketDailyOrderTracking, resendEyeTicketNotifications } from "../http/eyeticket.js";
import { fetchCoWorkers, fetchLinkedAccounts } from "../http/account.js";
import { formatDateToDDMMYYYY } from "../components/Helpers/dateFns.js";
import { ExpandedRowContainer } from "../components/StyledComponents/Table/TableComponents.jsx";
import { FieldContainer } from "../components/StyledComponents/Forms/Forms.jsx";
import TextInputWithLabel from "../components/Inputs/TextInput.jsx";
import { fetchDistributorEyeTickets } from "../http/distributor.js";
import { distributors, opticians, endUsers } from "../components/Helpers/userTypes.js";
import { authoriseSelfRaiseEyeTicket } from "../http/selfRaise.js";
import CheckboxWithLabel from "../components/Inputs/Checkbox.jsx";

const StyledModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  max-width: 500px;
`;



const ModalHeader = styled.h3`
  margin-top: 0;
  color: #333;
  text-align: center;
`;

const ModalBody = styled.div`
  margin: 20px 0;
`;

const WarningBox = styled.div`
  background-color: #fff3cd;
  border-left: 8px solid #ffeeba;
  padding: 15px;
  margin-bottom: 20px;
`;

const ModalFooter = styled.div`
  text-align: right;
`;

const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #5a6268;
  }
`;

const DeleteButton = styled(CancelButton)`
  background-color: #dc3545;
  &:hover {
    background-color: #c82333;
  }
`;

const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

const FormContainer = styled.div`
  border-radius: 5px;
  background-color: #fff;
  width: ${isMobile ? '100%' : '50%'};
`;


const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

const Button = styled.button`
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  font-size: 11px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin: 0 1px;

  &:hover {
    background-color: #0056b3;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const Heading = styled.h3`
  margin: 0;
  margin-top: 10px;
  padding-bottom: 5px;
`;

const Paragraph = styled.p`
  margin: 0 0 20px 0;
  font-size:15px;
`;

const ApproveButton = styled(Button)`
  width: 100%;
  background-color: #28a745;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 28px;
  &:hover:not(:disabled) {
    background-color: #218838;
  }
`;

const RejectButton = styled(Button)`
  width: 100%;
  background-color: #c91e27ff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 28px;
  &:hover:not(:disabled) {
    background-color: #e22d46ff;
  }
`;

const AuthoriseButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

const AuthoriseButtonRow = styled.div`
  display: flex;
  gap: 5px;
  width: 100%;
`;

const Spinner = styled.div`
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export default function TicketTracking({ colour, email, tempCCustId, accountType }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qpStatus = queryParams.get('tStatus');
  const qpAccount = queryParams.get('cAccount');
  const ticketRaised = queryParams.get('ticketRaised');
  const [isTicketUpdated, setIsTicketUpdated] = useState(null);

  const [authoriseLoadingState, setAuthoriseLoadingState] = useState({
    ticketId: null,
    action: null // 'Accept' or 'Reject'
  });

  const [qryParams, setQryParams] = useState({
    account: qpAccount,
    status: qpStatus,
    newEyeticket: ticketRaised
  });

  console.log(qryParams);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTicket, setCurrentTicket] = useState(null);
  const [modalType, setModalType] = useState(null);

  const [isNewEyeTicket, setIsNewEyeTicket] = React.useState(true);
  const [showEyeTicket, setShowEyeTicket] = React.useState(false);
  const [showProcessTicket, setShowProcessTicket] = React.useState(false);
  const [showTracking, setShowTracking] = React.useState(false);

  const [eyeTickets, setEyeTickets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [eyeticketCount, setEyeticketCount] = useState(0);

  const [linkedAccounts, setLinkedAccounts] = useState([]);
  const [coWorkers, setCoWorkers] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);



  const [pagingTracker, setPagingTracker] = useState(
    {
      currentPage: 1,
      pageSize: 10,
      filterStatus: null,
      searchValue: null,
      account: null,
      coWorker: null
    });

  const [searchParams] = useSearchParams();
  const isPrivate = searchParams.get('private');

  function ShowHideProcessEyeTicket() {
    setShowProcessTicket(!showProcessTicket);
  }

  function renderTickets() {
    loadEyeTickets(pagingTracker.account, pagingTracker.currentPage, pagingTracker.pageSize, pagingTracker.filterStatus, pagingTracker.searchValue);
  }

  function ShowHideEyeTicket(isNewTicket = true, isCancel = false) {
    renderTickets();
    setShowEyeTicket(!showEyeTicket);

    if (!isCancel) {
      if (isNewTicket === false) {
        setIsTicketUpdated('Ticket updated successfully');
      } else if (isNewTicket === true) {
        setIsTicketUpdated('Ticket raised successfully');
      }
    }
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setQryParams({
      account: queryParams.get('cAccount'),
      status: queryParams.get('tStatus'),
      newEyeticket: queryParams.get('ticketRaised')
    });
  }, [location.search]);


  function ShowHideTracking() {
    setShowTracking(!showTracking);
  }

  useEffect(() => {
    const loadLinkedAccounts = async () => {
      setIsLoading(true);
      try {
        const accounts = await fetchLinkedAccounts(email);
        const userAccounts = [];

        accounts.forEach(account => {
          userAccounts.push({ label: account.accountdescrip, value: account.accountid });
        });

        setLinkedAccounts(userAccounts);
        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };

    const loadCoWorkers = async () => {
      setIsLoading(true);
      try {
        const coWorkers = await fetchCoWorkers();
        const coWorkerList = [];

        coWorkers.forEach(coWorker => {
          coWorkerList.push({ label: coWorker.fullname, value: coWorker.eaddress, account: coWorker.accountid });
        });

        setCoWorkers(coWorkerList);
        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };

    loadLinkedAccounts();
    loadCoWorkers();
  }, [email]);

  const loadEyeTicketStatuses = async () => {
    setIsLoading(true);
    try {
      const response = await fetchTicketStatuses();
      setStatusOptions(response);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (linkedAccounts.length > 0) {
      loadEyeTicketStatuses();
    }
  }, [linkedAccounts]);

  const loadEyeTickets = useCallback(async (account, page, pageSize, status = null, searchValue = null, coWorker = null) => {
    setIsLoading(true);

    if (account || linkedAccounts) {
      try {
        const fetchedEyeTickets = await (async () => {
          if (opticians.includes(accountType)) {
            return fetchOpticiansEyeTickets(page, pageSize, searchValue, status);
          } else if (distributors.includes(accountType)) {
            return fetchDistributorEyeTickets(account ? account : linkedAccounts[0].value, page, pageSize, status, searchValue, coWorker);
          } else {
            return fetchUsersEyeTickets(account ? account : linkedAccounts[0].value, page, pageSize, status, searchValue, coWorker);
          }
        })();


        if (fetchedEyeTickets && fetchedEyeTickets[0].History) {
          const restructuredEyeTickets = fetchedEyeTickets[0].History.map(ticket => ({
            ...ticket,
            eyeticketTitle: `${ticket.EyeTicket.etickettitle} ${ticket.EyeTicket.eticketchrist} ${ticket.EyeTicket.eticketsurn}`,
            additional: (ticket.EyeTicket.eticket_sighttest === 0 ? '-' : 'Sight Test Included'),
            eyeTicketDate: formatDateToDDMMYYYY(ticket.EyeTicket.eticketdate, true)
          }));

          setEyeTickets(restructuredEyeTickets);
          setEyeticketCount((opticians.includes(accountType) ? fetchedEyeTickets[0].Count : fetchedEyeTickets[0].EyeticketCount));
        } else {
          setEyeTickets([]);
          setEyeticketCount(0);
        }
        setError(null);
      } catch (e) {
        setError(e);
        setEyeTickets([]);
        setEyeticketCount(0);
      } finally {
        setIsLoading(false);
      }
    }
  }, [accountType, email, tempCCustId, linkedAccounts]);

  const handleEnableDisableDailyOrderTracking = async (eyeTicketId, enabled) => {
    setIsLoading(true);
    try {
      await setEyeTicketDailyOrderTracking(eyeTicketId, enabled);
      renderTickets();
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendNotifications = async (eyeTicketId) => {
    setIsLoading(true);
    try {
      await resendEyeTicketNotifications(eyeTicketId);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEyeTicket = async () => {
    if (!currentTicket) return;
    setIsLoading(true);
    try {
      await updateEyeTicketStatus(currentTicket.EyeTicket.etickunid, 'Cancelled');
      setCurrentTicket(null);
      renderTickets();
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAuthoriseTicket = useCallback(async (eyeTicket, authorise) => {
    if (!eyeTicket) return;
    setIsLoading(true);

    setAuthoriseLoadingState({
      ticketId: eyeTicket.etickunid,
      action: authorise
    });

    try {
      await authoriseSelfRaiseEyeTicket(eyeTicket, eyeTicket.eticket_barcode, eyeTicket.eticketsurn, authorise);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
      setCurrentTicket(null);
      setIsTicketUpdated(`EyeTicket with Id ${eyeTicket.eticket_barcode} for ${eyeTicket.etickettitle} ${eyeTicket.eticketchrist} ${eyeTicket.eticketsurn} has been ${authorise === 'Accept' ? 'approved' : 'rejected'}.`);
      loadEyeTickets(pagingTracker.account, pagingTracker.currentPage, pagingTracker.pageSize, pagingTracker.filterStatus, pagingTracker.searchValue, pagingTracker.coWorker);
      setError(null);
    }

    setAuthoriseLoadingState({
      ticketId: null,
      action: null
    });
  }, [pagingTracker, loadEyeTickets]);

  const columns = useMemo(
    () => {
      const allColumns = [
        {
          Header: "EyeTicket",
          accessor: "eyeticketTitle",
        },
        {
          Header: "Prescription No.",
          accessor: row => row.EyeTicket.eticket_barcode,
        },
        {
          Header: "Eyewear",
          accessor: row => row.EyeTicket.eticketsafetyorvdu,
        },
        {
          Header: "Created",
          accessor: row => row.eyeTicketDate,
        },
        {
          Header: "Additional",
          accessor: "additional",
        },
        {
          Header: "Status",
          accessor: row => row.EyeTicket.eticketstatus,
          Filter: SelectColumnFilter,
          filter: 'includes',
        },
        {
          width: 300,
          Header: "Actions",
          accessor: "actions",
          Cell: ({ row }) => {
            const status = row.original.EyeTicket.eticketstatus;

            const renderButtons = () => {
              switch (status) {
                case 'Open':
                  if (endUsers.includes(accountType)) {
                    return (
                      <>
                        <Button onClick={() => {
                          setCurrentTicket(row.original);
                          setShowEyeTicket(true);
                          setIsNewEyeTicket(false);
                        }}>Edit</Button>
                        <Button onClick={() => {
                          setCurrentTicket(row.original);
                          setModalType('delete');
                          setIsModalOpen(true);
                        }}>Cancel</Button>
                      </>
                    );
                  }
                case 'In Production':
                case 'Despatched':
                case 'Order On Hold':
                case 'Closed':
                  return <Button onClick={() => {
                    setCurrentTicket(row.original);
                    ShowHideTracking();
                  }}>View/Track</Button>;
                case 'Expired':
                case 'Due New Eyewear':
                  if (endUsers.includes(accountType)) {
                    return <Button onClick={() => {
                      setCurrentTicket(row.original);
                      setShowEyeTicket(true);
                      setIsNewEyeTicket(true);
                    }}>New EyeTicket</Button>;
                  }
                case 'Authorise':
                  const isCurrentTicketLoading = authoriseLoadingState.ticketId === row.original.EyeTicket.etickunid;
                  const isApprovingThisRow = isCurrentTicketLoading && authoriseLoadingState.action === 'Accept';
                  const isRejectingThisRow = isCurrentTicketLoading && authoriseLoadingState.action === 'Reject';

                  if (row.original.EyeTicket.eticket_selfraise !== true) {
                    return null;
                  }

                  if (distributors.includes(accountType) || (opticians.includes(accountType))) {
                    return null;
                  }

                  return (
                    <>
                      <Button onClick={() => {
                        setCurrentTicket(row.original);
                        setShowEyeTicket(true);
                        setIsNewEyeTicket(false);
                      }}>View Ticket</Button>
                      <AuthoriseButtonRow>
                        <ApproveButton
                          onClick={() => handleAuthoriseTicket(row.original.EyeTicket, 'Accept')}
                          disabled={isCurrentTicketLoading}>
                          {isApprovingThisRow && <Spinner />}
                          {isApprovingThisRow ? 'Approving...' : 'Approve'}
                        </ApproveButton>
                        <RejectButton
                          onClick={() => handleAuthoriseTicket(row.original.EyeTicket, 'Reject')}
                          disabled={isCurrentTicketLoading}>
                          {isRejectingThisRow && <Spinner />}
                          {isRejectingThisRow ? 'Rejecting...' : 'Reject'}
                        </RejectButton>
                      </AuthoriseButtonRow>
                    </>
                  );
                default:
                  return null;
              }
            };

            return <ButtonGroup><AuthoriseButtonContainer>{renderButtons()}</AuthoriseButtonContainer></ButtonGroup>;
          }
        },
      ];

      const mobileColumns = allColumns.filter(column => {
        if (isMobile && (column.Header === 'Sap/Order No' || column.Header === 'Additional' || column.Header === 'Eyewear')) {
          return false;
        }
        return true;
      });

      return isMobile ? mobileColumns : allColumns;
    },
    [isMobile, authoriseLoadingState, handleAuthoriseTicket]
  );

  const deleteModal = currentTicket && (
    <StyledModal>
      <ModalHeader>Cancel EyeTicket</ModalHeader>
      <ModalBody>
        <WarningBox>
          <strong>Warning</strong>
          <p>By cancelling this EyeTicket, you won't be able to recover it.</p>
        </WarningBox>
        {currentTicket && (
          <p>Are you sure you want to cancel this EyeTicket for {currentTicket.eyeticketTitle}?</p>
        )}
      </ModalBody>
      <ModalFooter>
        <CancelButton onClick={() => setIsModalOpen(false)}>No</CancelButton>
        <DeleteButton onClick={() => {
          handleCancelEyeTicket();
          setIsModalOpen(false);
        }}>Yes, Cancel This EyeTicket</DeleteButton>
      </ModalFooter>
    </StyledModal>
  );

  return (
    <>
      {showProcessTicket && <ProcessEyeTicket showHideModal={ShowHideProcessEyeTicket} isModalOpen={showProcessTicket} colours={colour} />}
      {showEyeTicket &&
        <EyeTicket
          ticket={currentTicket.EyeTicket}
          isNewEyeTicket={isNewEyeTicket}
          showHideModal={ShowHideEyeTicket}
          isModalOpen={showEyeTicket}
          email={email}
          colours={colour}
          sightTestOnly={currentTicket.EyeTicket.eticket_sighttest === 2} />}
      {showTracking &&
        <Tracking
          showHideModal={ShowHideTracking}
          isModalOpen={showTracking}
          colours={colour}
          eyeTicket={currentTicket} />}
      <Modal open={isModalOpen}>
        {currentTicket && modalType === 'delete' && deleteModal}
      </Modal>
      <CenterContainer>
        <FormContainer>
          <Card
            label={(isPrivate ? 'Private Order History and Tracking' : 'EyeTicket® History and Tracking')}
            headercolour={colour.sidebar}
            headerTextColour={colour.font}>
            <Heading>History and Tracking</Heading>
            <Paragraph>To track, and manage your {(isPrivate ? 'Private Orders' : 'EyeTickets')}, use the table below.</Paragraph>
            <ServerSidePagingTable
              columns={columns}
              filter={(opticians.includes(accountType))}
              pagingFn={loadEyeTickets}
              data={eyeTickets}
              recordCount={eyeticketCount}
              arrFilterOptions={statusOptions}
              filterLabel='Status'
              setPagingTracker={setPagingTracker}
              arrAccountFilters={(!opticians.includes(accountType) ? linkedAccounts : null)}
              arrCoWorkersFilter={(endUsers.includes(accountType) ? coWorkers : null)}
              qryParams={qryParams}
              info={isTicketUpdated ? isTicketUpdated : qryParams.newEyeticket ? 'Ticket raised successfully' : 'Click on a row to preview the EyeTicket'}
              type={isTicketUpdated || qryParams.newEyeticket ? 'success' : 'info'}
              expand={(rowData) => (
                <ExpandedRowContainer>
                  <h1 style={{ fontSize: "1.1rem", marginBottom: "12px" }}>
                    EyeTicket Summary for {rowData.eyeticketTitle}
                  </h1>
                  <>
                    <FieldContainer>
                      <TextInputWithLabel
                        label='Order No.'
                        value={rowData.EyeTicket.eticketorderno}
                        disabled />
                    </FieldContainer>
                    {endUsers.includes(accountType) && (
                      <FieldContainer>
                        <CheckboxWithLabel
                          label="Daily Order Tracking"
                          checked={rowData.EyeTicket.eticket_DailyOrderTrackingRequested}
                          onClick={() => handleEnableDisableDailyOrderTracking(rowData.EyeTicket.etickunid, !rowData.EyeTicket.eticket_DailyOrderTrackingRequested)}
                        />
                      </FieldContainer>)}
                    {rowData.EyeTicket.eticketstatus.toLowerCase() === 'open' && endUsers.includes(accountType) && (
                      <FieldContainer>
                        <Button
                          onClick={() => handleResendNotifications(rowData.EyeTicket.etickunid)}
                          disabled={isLoading}>
                          {isLoading && <Spinner />}
                          {isLoading ? 'Sending Notifications...' : 'Resend Notifications'}
                        </Button>
                      </FieldContainer>
                    )}
                  </>
                </ExpandedRowContainer>
              )}
            />
            {(error && !linkedAccounts) && <Alert type="error">Unable to render page due to <b>{error.message}</b></Alert>}
            {!eyeticketCount && <Alert type="information">No EyeTickets found.</Alert>}
          </Card>
        </FormContainer>
      </CenterContainer>
    </>
  );
}